var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Product = (function (Product) {

        Product.Messages = (function (Messages) {

            Messages.BindControl = function (context) {
                var data = {
                    context: context
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.BindControl', data);
            };



            Messages.BindControl.className = 'Vendd.Product.Messages.BindControl';

            Messages.SetQuantity = function (qty) {
                var data = {
                    qty: qty
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.SetQuantity', data);
            };
            Messages.SetQuantity.className = 'Vendd.Product.Messages.SetQuantity';

            Messages.SetSelected = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.SetSelected', data);
            };
            Messages.SetSelected.className = 'Vendd.Product.Messages.SetSelected';

            Messages.SetBundleItems = function (bundleItems) {
                var data = {
                    bundleItems: bundleItems //example: bundleItems: [{bundleProductId:'testValue', parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.SetBundleItems', data);
            };
            Messages.SetBundleItems.className = 'Vendd.Product.Messages.SetBundleItems';

            Messages.SetRecipeItems = function (recipeItems) {
                var data = {
                    recipeItems: recipeItems
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.SetRecipeItems', data);
            };
            Messages.SetRecipeItems.className = 'Vendd.Product.Messages.SetRecipeItems';

            Messages.SetComboItems = function (comboItems) {
                var data = {
                    comboItems: comboItems
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.SetComboItems', data);
            };
            Messages.SetComboItems.className = 'Vendd.Product.Messages.SetComboItems';

            Messages.Changed = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.Changed', data);
            };
            Messages.Changed.className = 'Vendd.Product.Messages.Changed';

            Messages.Notify = function (email) {
                var data = {
                    email: email
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.Notify', data);
            };
            Messages.Notify.className = 'Vendd.Product.Messages.Notify';

            Messages.NotifySuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.NotifySuccess', response);
            };
            Messages.NotifySuccess.className = 'Vendd.Product.Messages.NotifySuccess';

            Messages.NotifyFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.NotifyFailure', response);
            };
            Messages.NotifyFailure.className = 'Vendd.Product.Messages.NotifyFailure';

            //VDCORE-1320
            Messages.Review = function (title, description, rating, id) {

                var data = {
                    productid: id,
                    title: title,
                    description: description,
                    rating: rating,
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.Review', data);
            };
            Messages.Review.className = 'Vendd.Product.Messages.Review';

            Messages.ReviewSuccess = function (response, config) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.ReviewSuccess', response, config);
            };
            Messages.ReviewSuccess.className = 'Vendd.Product.Messages.ReviewSuccess';

            Messages.ReviewFailure = function (response, config) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.ReviewFailure', response, config);
            };
            Messages.ReviewFailure.className = 'Vendd.Product.Messages.ReviewFailure';

            Messages.ReviewVote = function (id, positive) {

                var data = {
                    helpfullness: {
                        id: id,
                        ispositivevote: positive
                    }
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.ReviewVote', data);
            };
            Messages.ReviewVote.className = 'Vendd.Product.Messages.ReviewVote';

            Messages.ReviewVoteSuccess = function (response, vote) {
                response.data = JSON.parse(response.data);

                var data = {
                    response: response,
                    vote: vote
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.ReviewVoteSuccess', data);
            };
            Messages.ReviewVoteSuccess.className = 'Vendd.Product.Messages.ReviewVoteSuccess';

            Messages.ReviewVoteFailure = function (response, vote) {
                response.data = JSON.parse(response.data);

                var data = {
                    response: response,
                    vote: vote
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.ReviewVoteFailure', data);
            };
            Messages.ReviewVoteFailure.className = 'Vendd.Product.Messages.ReviewVoteFailure';


            Messages.ProductSelected = function (id, list) {

                var data = {
                    id: id,
                    list: list
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.ProductSelected', data);
            };
            Messages.ProductSelected.className = 'Vendd.Product.Messages.ProductSelected';


            Messages.GetAvailableWarehouses = function (code) {

                var data = {
                    skuCode: code
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.GetAvailableWarehouses', data);
            };
            Messages.GetAvailableWarehouses.className = 'Vendd.Product.Messages.GetAvailableWarehouses';

            Messages.GetAvailableWarehousesSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.GetAvailableWarehousesSuccess', response);
            };
            Messages.GetAvailableWarehousesSuccess.className = 'Vendd.Product.Messages.GetAvailableWarehousesSuccess';

            Messages.GetAvailableWarehousesFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Product.Messages.GetAvailableWarehousesFailure', response);
            };
            Messages.GetAvailableWarehousesFailure.className = 'Vendd.Product.Messages.GetAvailableWarehousesFailure';
            return Messages;

        })(Product.Messages || {});

        return Product;

    })(Vendd.Product || {});

    return Vendd;

})(Vendd || {});